__turbopack_export_value__({
  "body-logo-18": "NoResults-module-scss-module__Mjgw4W__body-logo-18",
  "body-text-12": "NoResults-module-scss-module__Mjgw4W__body-text-12",
  "body-text-14": "NoResults-module-scss-module__Mjgw4W__body-text-14",
  "body-text-16": "NoResults-module-scss-module__Mjgw4W__body-text-16",
  "body-text-18": "NoResults-module-scss-module__Mjgw4W__body-text-18",
  "body-text-20": "NoResults-module-scss-module__Mjgw4W__body-text-20",
  "body-text-24": "NoResults-module-scss-module__Mjgw4W__body-text-24",
  "body-text-24-2": "NoResults-module-scss-module__Mjgw4W__body-text-24-2",
  "body-text-heading-2": "NoResults-module-scss-module__Mjgw4W__body-text-heading-2",
  "body-text-heading-3": "NoResults-module-scss-module__Mjgw4W__body-text-heading-3",
  "body-text-medium-14": "NoResults-module-scss-module__Mjgw4W__body-text-medium-14",
  "body-text-medium-16": "NoResults-module-scss-module__Mjgw4W__body-text-medium-16",
  "body-text-medium-18": "NoResults-module-scss-module__Mjgw4W__body-text-medium-18",
  "body-text-medium2-18": "NoResults-module-scss-module__Mjgw4W__body-text-medium2-18",
  "body-text2-14": "NoResults-module-scss-module__Mjgw4W__body-text2-14",
  "body-text2-16": "NoResults-module-scss-module__Mjgw4W__body-text2-16",
  "button-primary-text": "NoResults-module-scss-module__Mjgw4W__button-primary-text",
  "button-text": "NoResults-module-scss-module__Mjgw4W__button-text",
  "button2-text": "NoResults-module-scss-module__Mjgw4W__button2-text",
  "card-shadow": "NoResults-module-scss-module__Mjgw4W__card-shadow",
  "effect-menu": "NoResults-module-scss-module__Mjgw4W__effect-menu",
  "header-1": "NoResults-module-scss-module__Mjgw4W__header-1",
  "main-container": "NoResults-module-scss-module__Mjgw4W__main-container",
  "main-footer-container": "NoResults-module-scss-module__Mjgw4W__main-footer-container",
  "main-header-container": "NoResults-module-scss-module__Mjgw4W__main-header-container",
  "txt-12-bold": "NoResults-module-scss-module__Mjgw4W__txt-12-bold",
  "txt-14-bold": "NoResults-module-scss-module__Mjgw4W__txt-14-bold",
  "txt-14-bold-caps": "NoResults-module-scss-module__Mjgw4W__txt-14-bold-caps",
  "txt-14-med": "NoResults-module-scss-module__Mjgw4W__txt-14-med",
  "txt-16-bold": "NoResults-module-scss-module__Mjgw4W__txt-16-bold",
  "txt-16-med": "NoResults-module-scss-module__Mjgw4W__txt-16-med",
  "txt-18-bold": "NoResults-module-scss-module__Mjgw4W__txt-18-bold",
  "txt-18-medium": "NoResults-module-scss-module__Mjgw4W__txt-18-medium",
  "txt-18-medium-24": "NoResults-module-scss-module__Mjgw4W__txt-18-medium-24",
  "txt-24-semi": "NoResults-module-scss-module__Mjgw4W__txt-24-semi",
  "wrapper": "NoResults-module-scss-module__Mjgw4W__wrapper",
  "wrapper__children": "NoResults-module-scss-module__Mjgw4W__wrapper__children",
  "wrapper__image": "NoResults-module-scss-module__Mjgw4W__wrapper__image",
  "wrapper__title": "NoResults-module-scss-module__Mjgw4W__wrapper__title",
});
